import React, { useEffect, useState } from "react";
import {
  BookOpen,
  HeartHandshake,
  ThermometerSnowflake,
  Home,
  Stethoscope,
  TreePalm,
} from "lucide-react";
import { Link, useSearchParams } from "react-router-dom";

const ProjectsPage = () => {
  const [activeTab, setActiveTab] = useState("education");

  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  useEffect(() => {
    if (tab) {
      setActiveTab(tab);
    }
  }, [tab]);

  const projects = {
    education: {
      title: "শিক্ষা ব্যয়ভার প্রজেক্ট",
      icon: (
        <BookOpen
          size={24}
          className={activeTab === "education" ? "text-white" : "text-primary"}
        />
      ),
      description:
        "শিক্ষা একটি জাতির উন্নতির মূল ভিত্তি। একটি উন্নত ও সচেতন সমাজ গঠনের জন্য শিক্ষা অপরিহার্য। কিন্তু শিক্ষার প্রসারে একটি বড় বাধা হয়ে দাঁড়ায় এর ব্যয়ভার। বর্তমানে সরকারি এবং বেসরকারি শিক্ষাপ্রতিষ্ঠানে শিক্ষা গ্রহণের খরচ উল্লেখযোগ্য হারে বেড়েছে, যা অনেক পরিবারের জন্য চাপ সৃষ্টি করছে। এই প্রজেক্টে আমরা প্রতিবছর নূন্যতম একজন শিক্ষার্থীর শিক্ষা ব্যয়ভার বিষয়ক সমস্যা, তার প্রভাব ও সম্ভাব্য সমাধান নিয়ে কাজ করি।",
      details: [
        "ভর্তি ফি ও টিউশন ফি",
        "পাঠ্যবই ও সহায়ক শিক্ষাসামগ্রী",
        "ইউনিফর্ম, পরিবহন ও খাবারের খরচ",
        "প্রাইভেট টিউশন বা কোচিং",
        "প্রযুক্তি ও ইন্টারনেট সংযোগ (অনলাইন শিক্ষার ক্ষেত্রে)",
      ],
      image:
        "https://plus.unsplash.com/premium_photo-1681487998119-b8a0aadf307f",
    },
    empowerment: {
      title: "সাবলম্বীকরণ প্রজেক্ট",
      icon: (
        <HeartHandshake
          size={24}
          className={
            activeTab === "empowerment" ? "text-white" : "text-primary"
          }
        />
      ),
      description:
        "একটি দেশের টেকসই উন্নয়নের জন্য দরকার আত্মনির্ভরশীল নাগরিক। সাবলম্বিতা বা আত্মনির্ভরতা মানুষের সম্মানজনক জীবনের মূল চাবিকাঠি। সাবলম্বীকরণ প্রজেক্ট হচ্ছে এমন একটি কার্যক্রম, যার মাধ্যমে ব্যক্তিকে নিজের পায়ে দাঁড়াতে সহায়তা করা হয় — অর্থাৎ তিনি যেন নিজের উপার্জনে নিজের ও পরিবারের প্রয়োজন মেটাতে পারেন।",
      details: [
        "মানুষের কর্মসংস্থানের সুযোগ সৃষ্টি করা",
        "আত্মবিশ্বাস গড়ে তোলা",
        "বেকারত্ব হ্রাস করা",
        "দারিদ্র্য দূরীকরণ",
        "আর্থসামাজিক উন্নয়ন নিশ্চিত করা",
      ],
      image:
        "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    },
    winter: {
      title: "শীতার্তদের শীতবস্ত্র",
      icon: (
        <ThermometerSnowflake
          size={24}
          className={activeTab === "winter" ? "text-white" : "text-primary"}
        />
      ),
      description:
        "বাংলাদেশ একটি ঋতুবৈচিত্র্যময় দেশ। শীতকাল আমাদের জন্য উৎসব ও উষ্ণতার ঋতু হলেও দেশের অনেক মানুষ, বিশেষ করে দরিদ্র ও অসহায় জনগোষ্ঠীর জন্য এটি এক নিদারুণ কষ্টের সময়। গরম কাপড়ের অভাবে অনেক মানুষ ঠাণ্ডাজনিত রোগে আক্রান্ত হন, এমনকি মৃত্যুবরণ করেন। এই প্রেক্ষাপটে শীতার্তদের শীতবস্ত্র প্রজেক্ট একটি মানবিক উদ্যোগ, যার মাধ্যমে সমাজের অবহেলিত মানুষদের মাঝে শীতবস্ত্র বিতরণ করা হয়।",
      details: [
        "দরিদ্র ও শীতার্ত মানুষদের মাঝে শীতবস্ত্র বিতরণ করা",
        "সামাজিক দায়িত্ববোধ সৃষ্টি করা",
        "শীতজনিত রোগ ও কষ্ট কিছুটা লাঘব করা",
        "ছাত্র-ছাত্রী, তরুণ সমাজ ও সংগঠনকে সমাজসেবায় সম্পৃক্ত করা",
      ],
      image:
        "https://images.unsplash.com/photo-1518895949257-7621c3c786d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1588&q=80",
    },
    shelter: {
      title: "আশ্রয়ণ প্রজেক্ট",
      icon: (
        <Home
          size={24}
          className={activeTab === "shelter" ? "text-white" : "text-primary"}
        />
      ),
      description:
        "আশ্রয় একটি মৌলিক অধিকার—এই ভাবনা থেকেই আমরাও গৃহহীন ও ভূমিহীন মানুষদের জন্য চালু করেছি অন্যতম বৃহৎ সামাজিক নিরাপত্তা প্রকল্প আশ্রয়ণ, যার মাধ্যমে অসহায় মানুষদের ঘর এবং জীবিকার ব্যবস্থা নিশ্চিত করা হয়।",
      details: [
        "গৃহহীন ও ভূমিহীন পরিবারকে বসবাসযোগ্য ঘর প্রদান",
        "তাদের পুনর্বাসন নিশ্চিত করা",
        "জীবিকা, স্বাস্থ্য, শিক্ষা ও সামাজিক নিরাপত্তা নিশ্চিত করা",
        "দারিদ্র্য দূরীকরণ ও টেকসই উন্নয়ন নিশ্চিত করা",
      ],
      image:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1473&q=80",
    },
    medical: {
      title: "ফ্রি মেডিকেল ও রক্তগ্রুপ নির্ণয় কর্মসূচি",
      icon: (
        <Stethoscope
          size={24}
          className={activeTab === "medical" ? "text-white" : "text-primary"}
        />
      ),
      description:
        "মানুষের সুস্থ জীবনযাপনের জন্য প্রয়োজন সচেতনতা ও সময়োপযোগী চিকিৎসা। কিন্তু অনেকেই দারিদ্র্য, অসচেতনতা বা সময়ের অভাবে নিয়মিত স্বাস্থ্যপরীক্ষা বা রক্তের গ্রুপ সম্পর্কে অবগত হতে পারেন না। তাই সামাজিক দায়িত্ববোধ থেকে আমাদের উদ্যোগ — ফ্রি মেডিকেল ও রক্তগ্রুপ নির্ণয় ক্যাম্প।",
      details: [
        "বিনামূল্যে স্বাস্থ্যপরীক্ষা",
        "রক্তচাপ ও ডায়াবেটিস পরীক্ষা",
        "রক্তের গ্রুপ নির্ধারণ",
        "প্রয়োজনীয় পরামর্শ ও ওষুধ বিতরণ",
      ],
      image:
        "https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    },
    tree: {
      title: "বৃক্ষরোপন কর্মসূচি",
      icon: (
        <TreePalm
          size={24}
          className={activeTab === "tree" ? "text-white" : "text-primary"}
        />
      ),
      description:
        "গাছ লাগান, পরিবেশ বাঁচান। বৃক্ষ আমাদের জীবনের অপরিহার্য অংশ। পরিবেশ রক্ষা, বায়ু বিশুদ্ধকরণ, ছায়া প্রদান, প্রাকৃতিক ভারসাম্য বজায় রাখা—সবই গাছের অবদান। আজ যখন জলবায়ু পরিবর্তনের প্রভাব আমাদের জীবনে ভয়াবহ আকার নিচ্ছে, তখন প্রয়োজন সচেতন উদ্যোগ ও কর্মপরিকল্পনা।",
      details: [
        "বিভিন্ন প্রজাতির চারা রোপণ",
        "পরিবেশ সচেতনতা মূলক আলোচনা",
        "অংশগ্রহণকারীদের মাঝে চারা বিতরণ",
        "সবুজ বাংলাদেশ গড়ার প্রত্যয়",
      ],
      image: "https://images.unsplash.com/photo-1502082553048-f009c37129b9",
    },
  };

  const activeProject = projects[activeTab];

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-black mb-4">
            আমাদের প্রকল্পসমূহ
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            সমাজ উন্নয়ন ও মানবসেবায় আমাদের বিভিন্ন কার্যক্রম
          </p>
        </div>

        {/* Project Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {Object.entries(projects).map(([key, project]) => (
            <button
              key={key}
              onClick={() => setActiveTab(key)}
              className={`px-4 py-3 rounded-lg font-medium flex items-center gap-2 transition-all border ${
                activeTab === key
                  ? "bg-primary text-white border-primary shadow-md"
                  : "bg-white text-black border-gray-200 hover:bg-gray-50"
              }`}
            >
              {project.icon}
              {project.title}
            </button>
          ))}
        </div>

        {/* Project Details */}
        <div className="rounded-xl overflow-hidden shadow-md border border-gray-100">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="p-8 md:p-12 bg-white">
              <div className="flex items-center gap-3 mb-6">
                <div className="p-3 rounded-full bg-primary/80">
                  {activeProject.icon}
                </div>
                <h2 className="text-3xl font-bold text-black">
                  {activeProject.title}
                </h2>
              </div>

              <p className="text-lg text-gray-700 mb-6">
                {activeProject.description}
              </p>

              <div className="space-y-4 mb-8">
                <h3 className="text-xl font-semibold text-black">
                  প্রকল্পের মূল কার্যক্রম:
                </h3>
                <ul className="space-y-3">
                  {activeProject.details.map((detail, index) => (
                    <li key={index} className="flex items-start">
                      <div className="flex-shrink-0 h-5 w-5 text-primary mr-2 mt-0.5">
                        <svg
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </div>
                      <span className="text-gray-700">{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <Link
                to={"/donation"}
                className="px-6 py-3 bg-primary text-white font-medium rounded-lg shadow hover:bg-primary/90 transition"
              >
                এই প্রকল্পে সহযোগিতা করুন
              </Link>
            </div>

            <div className="h-full w-full bg-gray-50 flex items-center justify-center p-4">
              <img
                src={activeProject.image}
                alt={activeProject.title}
                className="w-full h-full max-h-96 object-cover rounded-lg shadow-sm"
              />
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <h2 className="text-2xl font-bold text-black mb-4">
            আপনিও অংশ নিন আমাদের এই মহৎ কাজে
          </h2>
          <p className="text-gray-600 mb-6 max-w-3xl mx-auto">
            আপনার ছোট্ট একটি সহযোগিতা পারে একজন মানুষের জীবন বদলে দিতে। আসুন,
            আমরা সবাই মিলে একটি সুন্দর সমাজ গড়ি।
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <button className="px-6 py-3 bg-primary text-white font-medium rounded-lg shadow hover:bg-primary/90 transition">
              স্বেচ্ছাসেবক হোন
            </button>
            <button className="px-6 py-3 bg-black text-white font-medium rounded-lg shadow hover:bg-gray-800 transition">
              অনুদান দিন
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsPage;
